import moment from 'moment';
import { call, put, select } from 'redux-saga/effects';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import analyticsService from 'services/analyticsService';
import supplierSettingsService from 'services/supplierSettingsService';

import { getGroupId, getFeatureFlagValue } from 'store/session/selectors';

import history from 'utils/browserHistory';

import { initAnalytics, analyticsAuthenticate, initExplore } from './actions';
import { getAuthInfo, getTimezone } from './reducer';

function* getAuth() {
  const authInfo = yield select(getAuthInfo);
  if (!authInfo || authInfo.expiration < moment()) {
    const response = yield call(analyticsService.authentication.get);
    const auth = {
      token: response.token,
      expiration: moment().add(response.expiresIn, 'seconds'),
    };
    yield put(analyticsAuthenticate.success({ authInfo: auth }));
    return auth;
  }
  return authInfo;
}

export function* initExplorePage({ match }) {
  const hasAdvancedAnalyticsEnabled = yield select(
    getFeatureFlagValue,
    featureFlagKeys.isAdvancedAnalyticsEnabled,
  );
  if (hasAdvancedAnalyticsEnabled) {
    yield put(initExplore.request());
    try {
      yield call(getAuth);
      const queryId = match.params.queryId;
      let tz = yield select(getTimezone);
      if (!tz) {
        const groupId = yield select(getGroupId);
        const { timezone } = yield call(
          supplierSettingsService.getAnalyticsSettings,
          groupId,
        );
        tz = timezone;
      }
      yield put(initExplore.success({ queryId, timezone: tz }));
    } catch (err) {
      yield put(initExplore.error(err));
    }
  } else {
    history.push('/analytics/dashboards');
  }
}

export function* initAdvancedAnalytics() {
  yield put(initAnalytics.request());
  try {
    yield call(getAuth);
    const dashboards = yield call(analyticsService.dashboards.list);
    let defaultDashboard = dashboards.find((d) => d.isDefault);
    const sortedDashboards = dashboards.sort(
      (a, b) => Number(b.isDefault) - Number(a.isDefault),
    );
    if (!defaultDashboard) {
      defaultDashboard = sortedDashboards[0];
    }
    const groupId = yield select(getGroupId);
    const { timezone } = yield call(
      supplierSettingsService.getAnalyticsSettings,
      groupId,
    );
    yield put(
      initAnalytics.success({
        dashboards: sortedDashboards,
        defaultDashboardId: defaultDashboard.id,
        timezone: timezone,
      }),
    );
  } catch (err) {
    yield put(initAnalytics.error(err));
  }
}
